$icon-col-width: 2.5rem;

.ds-alert {

  &--hidden {
    display: none;
  }

  &__wrapper {
    padding: 2rem;
    display: flex;
    align-items: top;
    align-content: center;
  }

  &__left {
    padding-right: 1.5rem;
  }

  &__center {
    flex-grow: 1;
  }

  &__right {
    padding-left: 0.5rem;
  }

  &__title {
    padding-bottom: 0.25rem;
  }

  &__close-btn {
    cursor: pointer;
    margin: 0;
    padding: 0;
    border: 0;
    background-color: inherit;
    :hover {
      outline: none;
    }
  }
}

.ds-alert {
  &--info {
    .ds-alert__close-btn:hover {
      color: $ds-color-blaa;
    }
  }
  &--success {
    .ds-alert__close-btn:hover {
      color: $ds-color-svalgroenn;
    }
  }
  &--warning {
    .ds-alert__close-btn:hover {
      color: $ds-color-rust;
    }
  }
  &--danger { 
    .ds-alert__close-btn {
      color: $ds-color-white;

      &:hover {
        color: $ds-color-rust;
      }
    }
  }
}